import BodyText from "components/Typography/BodyText"
import { memo } from "react"
import styled from "styled-components"

const ContainerList = styled.ul`
  &.disc {
    list-style: disc;
  }

  &.circle {
    list-style: circle;
  }

  &.none {
    list-style: none;
  }
`

const ItemList = styled.li`
  display: flex;
  flex-direction: column;

  &.list-item {
    margin-left: 16px;
    display: list-item;

    &::marker {
      font-size: 12px;
    }
  }
`

interface ListTypeDiscProps {
  title?: string
  description?: string | JSX.Element
  className?: string
  classNameLI?: string
}

const ListTypeDisc = (props: ListTypeDiscProps) => {
  const { title, description, className = "none", classNameLI } = props

  return (
    <ContainerList className={className}>
      <ItemList className={classNameLI}>
        <BodyText size="medium" weight="regular" color="gray-dark">
          <b>{title}</b> {description}
        </BodyText>
      </ItemList>
    </ContainerList>
  )
}

export default memo(ListTypeDisc)
